import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CallbackWidget from "./CallbackWidget";
import MobileStickyCTA from "./MobileStickyCTA";

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#FAFAF9]">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CallbackWidget />
      <MobileStickyCTA />
    </div>
  );
}
